exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../../../../../../node_modules/postcss-loader/index.js!../../../../../styles.css"), "");

// module
exports.push([module.id, ".centered {\n    text-align: center;\n}\n\n.checkbox {\n    width: 15px;\n    height: 15px;\n    margin: 5px;\n  }\n  \n  .table{\n    margin-top: 15px;\n  }\n  \n  tr>th:first-child, tr>td:first-child {\n      text-align: center;\n  }\n\n  td>label {\n      font-weight: unset;\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/modal/content-updated-info-edcast/content-updated-info-edcast.component.css
// module id = 838
// module chunks = 0